import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';

import { PaginatedResultModel, PaginationSearchModel } from '@data-layer/models/common';
import {
  ManagementPackingListItemModel,
  ManagementPackingListModel,
  ManagementUpdatePackingListItemModel,
} from '@data-layer/models/management';

@Injectable({
  providedIn: 'root',
})
export class PackingListItemsRepository {
  constructor(private apiService: ApiService) {}

  public search(
    params?: PaginationSearchModel,
    isShowLoader?: boolean,
    isUsed: boolean = false,
  ): Observable<PaginatedResultModel<ManagementPackingListItemModel>> {
    return this.apiService.get<PaginatedResultModel<ManagementPackingListItemModel>>(
      environment.url.freight.packingListItemsManagement,
      { params },
      { isShowLoader, isUsed },
    );
  }

  public searchByPackingList(
    packingListId: ManagementPackingListModel['id'],
    params: PaginationSearchModel,
    isShowLoader?: boolean,
  ): Observable<PaginatedResultModel<ManagementPackingListItemModel>> {
    return this.apiService.get<PaginatedResultModel<ManagementPackingListItemModel>>(
      `${environment.url.freight.packingListsManagement}/${packingListId}/items`,
      { params },
      {
        isShowLoader,
      },
    );
  }

  public create(
    packingListId: ManagementPackingListModel['id'],
    model: ManagementUpdatePackingListItemModel,
    isShowLoader?: boolean,
  ): Observable<ManagementPackingListItemModel> {
    return this.apiService.post<ManagementPackingListItemModel>(
      `${environment.url.freight.packingListsManagement}/${packingListId}/items`,
      model,
      null,
      {
        isShowLoader,
      },
    );
  }

  public get(id: ManagementPackingListItemModel['id'], isShowLoader?: boolean): Observable<ManagementPackingListItemModel> {
    return this.apiService.get<ManagementPackingListItemModel>(`${environment.url.freight.packingListItemsManagement}/${id}`, null, {
      isShowLoader,
    });
  }

  public update(
    id: ManagementPackingListItemModel['id'],
    model: ManagementUpdatePackingListItemModel,
    isShowLoader?: boolean,
  ): Observable<ManagementPackingListItemModel> {
    return this.apiService.put<ManagementPackingListItemModel>(`${environment.url.freight.packingListItemsManagement}/${id}`, model, null, {
      isShowLoader,
    });
  }

  public delete(id: ManagementPackingListItemModel['id'], isShowLoader?: boolean): Observable<never> {
    return this.apiService.delete(`${environment.url.freight.packingListItemsManagement}/${id}`, null, { isShowLoader });
  }
}
